<app-page-content>
<app-doenkids-menu-bar menuBar [loading]="isSearching$ | async" [backUrl]="backUrl$ | async">
  <div left>
    <app-activity-search-bar [query]="currentSearchParams?.query" (searched)="doSearch($event)"></app-activity-search-bar>
  </div>
</app-doenkids-menu-bar>
<div content>
<div class="page-container" #pageContainer>
  <app-split-page
    #splitPage
    [leftLabel]="'activity_search.tab.filters' | translate"
    [rightLabel]="'activity_search.tab.results' | translate"
    [activeTab]="1"
    [leftWidth]="30"
    [scrollEventsRight]="true"
    [hide]="hideAggregations$ | async"
    sideToHide="left"
    whatToHide="side"
    (scrollEndRight)="onScrollEnd()"
    (selectedTabChange)="tabChange($event)"
    >
    <ng-template #left>
      @if (baseAggregations$ | async) {
        <div class="aggregations">
          <app-search-aggregations
            [aggregationLabels]="aggregationLabels | async"
            [aggregationData]="baseAggregations$ | async"
            [formControl]="aggregationControl"
            >
          </app-search-aggregations>
        </div>
      }
    </ng-template>
    <ng-template #right>
      <div class="results-panel">
        <div class="results-header" #resultsHeader>
          <div class="results-header-wrapper" [class.hasFilters]="containsAggregations$ | async">
            <mat-toolbar class="mat-toolbar-doenkids">
              @if (!(isSmall$ | async)) {
                <button mat-icon-button (click)="toggleAggregations()">
                  @if (!(hideAggregations$ | async)) {
                    <mat-icon>chevron_left</mat-icon>
                  }
                  @if (hideAggregations$ | async) {
                    <mat-icon>chevron_right</mat-icon>
                  }
                </button>
              }
              @if (baseActivitySearchMetadata$ | async; as metaData) {
                <div class="result-amount">
                  @if (metaData?.total > 0) {
                    <span
                    [innerHTML]="'activity_search.search_metadata' | translate: {
                      resultCount: metaData?.total,
                    }"
                      >
                    </span>
                  }
                  @for (suggestion of baseSearchSuggestions$ | async; track suggestion) {
                    <span class="did-you-mean">
                      @if (suggestion.options && suggestion.options.length > 0) {
                        <span>{{ 'activity_search.suggestions' | translate }}&nbsp;</span>
                        @for (option of suggestion.options; track option) {
                          <a href="#" (click)="trySuggestion(option.text, $event)" [innerHTML]="option.highlighted"></a>
                        }
                        <span>?</span>
                      }
                    </span>
                  }
                </div>
              }
              <div class="spacer"></div>
            </mat-toolbar>
            @if (containsAggregations$ | async) {
              <mat-toolbar class="mat-toolbar-doenkids mat-toolbar-chips">
                <app-search-chips
                  [aggregationLabels]="aggregationLabels | async"
                  (onRemoveAll)="removeAllFilters()"
                  (onRemove)="removeFilter($event)"
                  [aggregationData]="baseAggregations$ | async"
                  [selection]="aggregationControl.value"
                  >
                </app-search-chips>
              </mat-toolbar>
            }
          </div>
        </div>

        <div class="search-results">
          @if (baseSearchResults$ | async; as results) {
            <div class="body-container animated fadeIn">
              @if (results.length > 0) {
                <ngx-masonry [options]="{ gutter: 25, transitionDuration: '0s', fitWidth: true, horizontalOrder: true }">
                  @for (activity of results; track activity) {
                    <ngxMasonryItem class="masonry-item">
                      <app-activity-card (loaded)="imageLoaded()" (click)="activityClicked(activity)" [activity]="activity"> </app-activity-card>
                    </ngxMasonryItem>
                  }
                </ngx-masonry>
              }
            </div>
            @if ((baseSearchResults$ | async).length === 0) {
              <div>
                {{ 'activity_search.no_results' | translate }}
              </div>
            }
          }
        </div>
      </div>
    </ng-template>
  </app-split-page>
</div>
</div>
<div fixed>
<router-outlet></router-outlet>
</div>
</app-page-content>
